import React, {useRef, useState} from 'react'
import {useIntl} from 'react-intl'

import {Button} from '@vio/atlas/Button'
import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {InputText} from '@vio/atlas/InputText'
import {useDebouncedEffect} from '@vio/core/src/utils/debounce/hooks/useDebouncedEffect'

import {reviewMessages} from '../ReviewMessages'

interface Props {
  onSearch: (search: string[]) => void
}

export const ReviewSearchInput: React.FC<Props> = ({onSearch}) => {
  const {formatMessage} = useIntl()
  const inputRef = useRef<HTMLInputElement>(null)

  const [searchReview, setSearchReview] = useState(null)

  const handleSubmit = () => {
    const keywords = searchReview.trim().split(' ').filter(Boolean)

    onSearch(keywords)
  }

  const handleClear = () => {
    setSearchReview('')
    onSearch([])
  }

  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    inputRef.current?.blur()
    handleSubmit()
  }

  useDebouncedEffect(
    () => {
      if (searchReview !== null) {
        handleSubmit()
      }
    },
    [searchReview],
    500
  )

  return (
    <Box paddingBottom="s600">
      <form onSubmit={handleFormSubmit}>
        <InputText
          ref={inputRef}
          dataId="reviewSectionSearchInput"
          id="searchReview"
          name="searchReview"
          prefix={<Icon name="Search" colorPath="content.brand.primary" />}
          value={searchReview}
          onChange={setSearchReview}
          suffix={
            searchReview && (
              <Button
                onClick={handleClear}
                variant="ghost"
                size="sm"
                iconStart={
                  <Icon
                    name="Clear"
                    size="sm"
                    colorPath="content.neutral.secondary"
                  />
                }
              />
            )
          }
          placeholder={formatMessage(
            reviewMessages.reviewSectionSearchPlaceholder
          )}
        />
      </form>
    </Box>
  )
}
